import React from 'react';

export const icons = {
  add: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z" fill="currentColor" />
    </svg>
  ),
  add_circle: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z" />
    </svg>
  ),
  analysis: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M280-280h80v-200h-80v200Zm320 0h80v-400h-80v400Zm-160 0h80v-120h-80v120Zm0-200h80v-80h-80v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
    </svg>
  ),
  arrow_down: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M440-800v487L216-537l-56 57 320 320 320-320-56-57-224 224v-487h-80Z" />
    </svg>
  ),
  arrow_right: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z" />
    </svg>
  ),
  arrow_up: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M440-160v-487L216-423l-56-57 320-320 320 320-56 57-224-224v487h-80Z" />
    </svg>
  ),
  attach_pdf: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0625 1.29504L18.54 4.92004V18.705H5.54938V18.75H18.5844V4.96567L15.0625 1.29504Z"
        fill="#909090"
      />
      <path d="M15.0194 1.25H5.505V18.705H18.54V4.92063L15.0194 1.25Z" fill="#F4F4F4" />
      <path d="M5.40937 2.1875H1.41562V6.45437H13.9781V2.1875H5.40937Z" fill="#7A7B7C" />
      <path d="M14.045 6.38182H1.49689V2.11182H14.045V6.38182Z" fill="#DD2025" />
      <path
        d="M5.65751 2.8338H4.84064V5.8338H5.48314V4.82193L5.62501 4.83005C5.76287 4.82768 5.89943 4.80299 6.02939 4.75693C6.14333 4.71774 6.24814 4.65587 6.33751 4.57505C6.42845 4.49807 6.50015 4.4009 6.54689 4.2913C6.60957 4.10912 6.63196 3.91549 6.61251 3.7238C6.60861 3.58687 6.5846 3.45126 6.54126 3.3213C6.50181 3.2275 6.44326 3.14293 6.36933 3.07299C6.29541 3.00305 6.20773 2.94926 6.11189 2.91505C6.02902 2.88505 5.9434 2.86328 5.85626 2.85005C5.79028 2.83987 5.72365 2.83444 5.65689 2.8338M5.53876 4.26755H5.48314V3.34255H5.60376C5.657 3.33872 5.71042 3.34689 5.76007 3.36647C5.80973 3.38605 5.85435 3.41654 5.89064 3.45568C5.96584 3.55631 6.00601 3.67881 6.00501 3.80443C6.00501 3.95818 6.00501 4.09755 5.86626 4.19568C5.7663 4.25066 5.65253 4.27604 5.53876 4.26755ZM7.83314 2.82568C7.76376 2.82568 7.69626 2.83068 7.64876 2.83255L7.50001 2.8363H7.01251V5.8363H7.58626C7.80553 5.84231 8.02384 5.80515 8.22876 5.72693C8.39371 5.66151 8.53977 5.55604 8.65376 5.42005C8.76461 5.28284 8.84417 5.12308 8.88689 4.95193C8.93599 4.7581 8.95994 4.55875 8.95814 4.3588C8.97026 4.12265 8.95199 3.88592 8.90376 3.65443C8.858 3.48403 8.7723 3.32699 8.65376 3.1963C8.56076 3.09078 8.44691 3.00566 8.31939 2.9463C8.20987 2.89563 8.09468 2.85828 7.97626 2.83505C7.92917 2.82728 7.88148 2.82372 7.83376 2.82443M7.72001 5.28505H7.65751V3.37005H7.66564C7.79449 3.35523 7.92486 3.37848 8.04064 3.43693C8.12543 3.50463 8.19452 3.58993 8.24314 3.68693C8.29561 3.78901 8.32586 3.90106 8.33189 4.01568C8.33751 4.15318 8.33189 4.26568 8.33189 4.3588C8.33443 4.46608 8.32753 4.57337 8.31126 4.67943C8.292 4.78832 8.25639 4.89368 8.20564 4.99193C8.14819 5.08328 8.07058 5.16025 7.97876 5.21693C7.90165 5.2668 7.81034 5.29007 7.71876 5.28318M10.8938 2.8363H9.37501V5.8363H10.0175V4.6463H10.83V4.0888H10.0175V3.3938H10.8925V2.8363"
        fill="#464648"
      />
      <path
        d="M13.6131 12.6593C13.6131 12.6593 15.6056 12.2981 15.6056 12.9787C15.6056 13.6593 14.3712 13.3824 13.6131 12.6593ZM12.14 12.7112C11.8234 12.7811 11.5149 12.8836 11.2194 13.0168L11.4694 12.4543C11.7194 11.8918 11.9787 11.1249 11.9787 11.1249C12.2771 11.627 12.6242 12.0985 13.015 12.5324C12.7203 12.5764 12.4281 12.6365 12.14 12.7124V12.7112ZM11.3512 8.6487C11.3512 8.05557 11.5431 7.8937 11.6925 7.8937C11.8419 7.8937 12.01 7.96557 12.0156 8.48057C11.9669 8.99842 11.8585 9.5089 11.6925 10.0018C11.4651 9.58797 11.3474 9.12278 11.3506 8.65057L11.3512 8.6487ZM8.44562 15.2212C7.83437 14.8556 9.72749 13.7299 10.0706 13.6937C10.0687 13.6943 9.08562 15.6037 8.44562 15.2212ZM16.1875 13.0593C16.1812 12.9968 16.125 12.3049 14.8937 12.3343C14.3805 12.326 13.8676 12.3622 13.3606 12.4424C12.8695 11.9477 12.4466 11.3896 12.1031 10.7831C12.3195 10.1577 12.4505 9.50599 12.4925 8.84557C12.4744 8.09557 12.295 7.66557 11.72 7.67182C11.145 7.67807 11.0612 8.1812 11.1369 8.92995C11.2109 9.4331 11.3507 9.92437 11.5525 10.3912C11.5525 10.3912 11.2869 11.2181 10.9356 12.0406C10.5844 12.8631 10.3444 13.2943 10.3444 13.2943C9.73357 13.4932 9.15857 13.7886 8.64124 14.1693C8.12624 14.6487 7.91687 15.0168 8.18812 15.3849C8.42187 15.7024 9.23999 15.7743 9.97124 14.8162C10.3598 14.3213 10.7147 13.801 11.0337 13.2587C11.0337 13.2587 12.1487 12.9531 12.4956 12.8693C12.8425 12.7856 13.2619 12.7193 13.2619 12.7193C13.2619 12.7193 14.28 13.7437 15.2619 13.7074C16.2437 13.6712 16.1962 13.1206 16.19 13.0606"
        fill="#DD2025"
      />
      <path d="M14.9713 1.2981V4.96872H18.4919L14.9713 1.2981Z" fill="#909090" />
      <path d="M15.0194 1.25V4.92063H18.54L15.0194 1.25Z" fill="#F4F4F4" />
      <path
        d="M5.60939 2.78559H4.79251V5.78559H5.43751V4.77434L5.58001 4.78246C5.71787 4.78009 5.85443 4.75539 5.98439 4.70934C6.09832 4.67013 6.20313 4.60826 6.29251 4.52746C6.38277 4.45027 6.45381 4.35312 6.50001 4.24371C6.56269 4.06152 6.58509 3.8679 6.56564 3.67621C6.56173 3.53928 6.53773 3.40366 6.49439 3.27371C6.45493 3.1799 6.39638 3.09534 6.32246 3.02539C6.24853 2.95545 6.16086 2.90167 6.06501 2.86746C5.98176 2.83717 5.89572 2.81519 5.80814 2.80184C5.74215 2.79166 5.67552 2.78623 5.60876 2.78559M5.49064 4.21934H5.43501V3.29434H5.55626C5.6095 3.2905 5.66292 3.29867 5.71257 3.31825C5.76223 3.33783 5.80685 3.36832 5.84314 3.40746C5.91833 3.5081 5.95851 3.63059 5.95751 3.75621C5.95751 3.90996 5.95751 4.04934 5.81876 4.14746C5.7188 4.20244 5.60502 4.22719 5.49126 4.21871M7.78501 2.77746C7.71564 2.77746 7.64814 2.78246 7.60064 2.78434L7.45376 2.78809H6.96626V5.78809H7.54001C7.75928 5.7941 7.97758 5.75693 8.18251 5.67871C8.34746 5.61329 8.49352 5.50782 8.60751 5.37184C8.71836 5.23462 8.79792 5.07486 8.84064 4.90371C8.88974 4.70988 8.91368 4.51053 8.91189 4.31059C8.92401 4.07443 8.90573 3.8377 8.85751 3.60621C8.81175 3.43581 8.72605 3.27877 8.60751 3.14809C8.51451 3.04256 8.40066 2.95744 8.27314 2.89809C8.16362 2.84741 8.04842 2.81006 7.93001 2.78684C7.88292 2.77906 7.83523 2.7755 7.78751 2.77621M7.67376 5.23684H7.61126V3.32184H7.61939C7.74823 3.30701 7.8786 3.33026 7.99439 3.38871C8.07917 3.45642 8.14826 3.54171 8.19689 3.63871C8.24936 3.7408 8.27961 3.85284 8.28564 3.96746C8.29126 4.10496 8.28564 4.21746 8.28564 4.31059C8.28818 4.41786 8.28128 4.52515 8.26501 4.63121C8.24575 4.7401 8.21014 4.84546 8.15939 4.94371C8.10194 5.03506 8.02433 5.11203 7.93251 5.16871C7.8554 5.21859 7.76409 5.24185 7.67251 5.23496M10.8456 2.78809H9.32689V5.78809H9.96939V4.59809H10.7819V4.04059H9.96939V3.34559H10.8444V2.78809"
        fill="white"
      />
    </svg>
  ),
  automation: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22.5C10.95 22.5 10.0625 22.1375 9.3375 21.4125C8.6125 20.6875 8.25 19.8 8.25 18.75C8.25 17.8833 8.50833 17.1208 9.025 16.4625C9.54167 15.8042 10.2 15.3583 11 15.125V13H5V9H2.5V2H9.5V9H7V11H17V8.875C16.2 8.64167 15.5417 8.19583 15.025 7.5375C14.5083 6.87917 14.25 6.11667 14.25 5.25C14.25 4.2 14.6125 3.3125 15.3375 2.5875C16.0625 1.8625 16.95 1.5 18 1.5C19.05 1.5 19.9375 1.8625 20.6625 2.5875C21.3875 3.3125 21.75 4.2 21.75 5.25C21.75 6.11667 21.4917 6.87917 20.975 7.5375C20.4583 8.19583 19.8 8.64167 19 8.875V13H13V15.125C13.8 15.3583 14.4583 15.8042 14.975 16.4625C15.4917 17.1208 15.75 17.8833 15.75 18.75C15.75 19.8 15.3875 20.6875 14.6625 21.4125C13.9375 22.1375 13.05 22.5 12 22.5ZM18 7C18.4833 7 18.8958 6.82917 19.2375 6.4875C19.5792 6.14583 19.75 5.73333 19.75 5.25C19.75 4.76667 19.5792 4.35417 19.2375 4.0125C18.8958 3.67083 18.4833 3.5 18 3.5C17.5167 3.5 17.1042 3.67083 16.7625 4.0125C16.4208 4.35417 16.25 4.76667 16.25 5.25C16.25 5.73333 16.4208 6.14583 16.7625 6.4875C17.1042 6.82917 17.5167 7 18 7ZM4.5 7H7.5V4H4.5V7ZM12 20.5C12.4833 20.5 12.8958 20.3292 13.2375 19.9875C13.5792 19.6458 13.75 19.2333 13.75 18.75C13.75 18.2667 13.5792 17.8542 13.2375 17.5125C12.8958 17.1708 12.4833 17 12 17C11.5167 17 11.1042 17.1708 10.7625 17.5125C10.4208 17.8542 10.25 18.2667 10.25 18.75C10.25 19.2333 10.4208 19.6458 10.7625 19.9875C11.1042 20.3292 11.5167 20.5 12 20.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  balance: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 18V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.89 3 5 3H19C20.1 3 21 3.9 21 5V6H12C10.89 6 10 6.9 10 8V16C10 17.1 10.89 18 12 18H21ZM12 16H22V8H12V16ZM16 13.5C15.17 13.5 14.5 12.83 14.5 12C14.5 11.17 15.17 10.5 16 10.5C16.83 10.5 17.5 11.17 17.5 12C17.5 12.83 16.83 13.5 16 13.5Z"
        fill="currentColor"
      />
    </svg>
  ),
  book: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M300-80q-58 0-99-41t-41-99v-520q0-58 41-99t99-41h500v600q-25 0-42.5 17.5T740-220q0 25 17.5 42.5T800-160v80H300Zm-60-267q14-7 29-10t31-3h20v-440h-20q-25 0-42.5 17.5T240-740v393Zm160-13h320v-440H400v440Zm-160 13v-453 453Zm60 187h373q-6-14-9.5-28.5T660-220q0-16 3-31t10-29H300q-26 0-43 17.5T240-220q0 26 17 43t43 17Z"
        fill="currentColor"
      />
    </svg>
  ),
  bolt: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m422-232 207-248H469l29-227-185 267h139l-30 208ZM320-80l40-280H160l360-520h80l-40 320h240L400-80h-80Zm151-390Z"
        fill="currentColor"
      />
    </svg>
  ),
  check: (width, height) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M8.5 11.5 11 14l4-4m6 2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z"
      />
    </svg>
  ),
  calendar: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V8H20V21Z"
        fill="currentColor"
      />
    </svg>
  ),
  campaign: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 13V11H22V13H18ZM19.2 20L16 17.6L17.2 16L20.4 18.4L19.2 20ZM17.2 8L16 6.4L19.2 4L20.4 5.6L17.2 8ZM5 19V15H4C3.45 15 2.97917 14.8042 2.5875 14.4125C2.19583 14.0208 2 13.55 2 13V11C2 10.45 2.19583 9.97917 2.5875 9.5875C2.97917 9.19583 3.45 9 4 9H8L13 6V18L8 15H7V19H5ZM11 14.45V9.55L8.55 11H4V13H8.55L11 14.45ZM14 15.35V8.65C14.45 9.05 14.8125 9.5375 15.0875 10.1125C15.3625 10.6875 15.5 11.3167 15.5 12C15.5 12.6833 15.3625 13.3125 15.0875 13.8875C14.8125 14.4625 14.45 14.95 14 15.35Z"
        fill="currentColor"
      />
    </svg>
  ),
  cancel: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
        fill="currentColor"
      />
    </svg>
  ),
  check_circle: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
        fill="currentColor"
      />
    </svg>
  ),
  close: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
        fill="currentColor"
      />
    </svg>
  ),
  code: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m193-479 155 155q11 11 11 28t-11 28q-11 11-28 11t-28-11L108-452q-6-6-8.5-13T97-480q0-8 2.5-15t8.5-13l184-184q12-12 28.5-12t28.5 12q12 12 12 28.5T349-635L193-479Zm574-2L612-636q-11-11-11-28t11-28q11-11 28-11t28 11l184 184q6 6 8.5 13t2.5 15q0 8-2.5 15t-8.5 13L668-268q-12 12-28 11.5T612-269q-12-12-12-28.5t12-28.5l155-155Z"
        fill="currentColor"
      />
    </svg>
  ),
  colors: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M346-140 100-386q-10-10-15-22t-5-25q0-13 5-25t15-22l230-229-75-75q-13-13-13.5-31t12.5-32q13-14 32-14t33 14l367 367q10 10 14.5 22t4.5 25q0 13-4.5 25T686-386L440-140q-10 10-22 15t-25 5q-13 0-25-5t-22-15Zm47-506L179-432h428L393-646Zm399 526q-36 0-61-25.5T706-208q0-27 13.5-51t30.5-47l19-24q9-11 23.5-11.5T816-331l20 25q16 23 30 47t14 51q0 37-26 62.5T792-120Z"
        fill="currentColor"
      />
    </svg>
  ),
  copy: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M360-240q-33 0-56.5-23.5T280-320v-480q0-33 23.5-56.5T360-880h360q33 0 56.5 23.5T800-800v480q0 33-23.5 56.5T720-240H360Zm0-80h360v-480H360v480ZM200-80q-33 0-56.5-23.5T120-160v-560h80v560h440v80H200Zm160-240v-480 480Z"
        fill="currentColor"
      />
    </svg>
  ),
  dashboard: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 18V16L2 14V18H0ZM4 18V12L6 10V18H4ZM8 18V10L10 12.025V18H8ZM12 18V12.025L14 10.025V18H12ZM16 18V8L18 6V18H16ZM0 12.825V10L7 3L11 7L18 0V2.825L11 9.825L7 5.825L0 12.825Z"
        fill="currentColor"
      />
    </svg>
  ),
  download: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M160-80v-80h640v80H160Zm320-160L200-600h160v-280h240v280h160L480-240Zm0-130 116-150h-76v-280h-80v280h-76l116 150Zm0-150Z"
        fill="currentColor"
      />
    </svg>
  ),
  edit: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31 6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141 85-28-29 57 57-29-28Z"
        fill="currentColor"
      />
    </svg>
  ),
  expand: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z" fill="currentColor" />
    </svg>
  ),
  expand_down: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z" fill="currentColor" />
    </svg>
  ),
  expand_up: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M480-528 296-344l-56-56 240-240 240 240-56 56-184-184Z" fill="currentColor" />
    </svg>
  ),
  extension: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.8 21H5C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V15.2C3.8 15.2 4.5 14.9458 5.1 14.4375C5.7 13.9292 6 13.2833 6 12.5C6 11.7167 5.7 11.0708 5.1 10.5625C4.5 10.0542 3.8 9.8 3 9.8V6C3 5.45 3.19583 4.97917 3.5875 4.5875C3.97917 4.19583 4.45 4 5 4H9C9 3.3 9.24167 2.70833 9.725 2.225C10.2083 1.74167 10.8 1.5 11.5 1.5C12.2 1.5 12.7917 1.74167 13.275 2.225C13.7583 2.70833 14 3.3 14 4H18C18.55 4 19.0208 4.19583 19.4125 4.5875C19.8042 4.97917 20 5.45 20 6V10C20.7 10 21.2917 10.2417 21.775 10.725C22.2583 11.2083 22.5 11.8 22.5 12.5C22.5 13.2 22.2583 13.7917 21.775 14.275C21.2917 14.7583 20.7 15 20 15V19C20 19.55 19.8042 20.0208 19.4125 20.4125C19.0208 20.8042 18.55 21 18 21H14.2C14.2 20.1667 13.9375 19.4583 13.4125 18.875C12.8875 18.2917 12.25 18 11.5 18C10.75 18 10.1125 18.2917 9.5875 18.875C9.0625 19.4583 8.8 20.1667 8.8 21ZM5 19H7.125C7.525 17.9 8.16667 17.125 9.05 16.675C9.93333 16.225 10.75 16 11.5 16C12.25 16 13.0667 16.225 13.95 16.675C14.8333 17.125 15.475 17.9 15.875 19H18V13H20C20.1333 13 20.25 12.95 20.35 12.85C20.45 12.75 20.5 12.6333 20.5 12.5C20.5 12.3667 20.45 12.25 20.35 12.15C20.25 12.05 20.1333 12 20 12H18V6H12V4C12 3.86667 11.95 3.75 11.85 3.65C11.75 3.55 11.6333 3.5 11.5 3.5C11.3667 3.5 11.25 3.55 11.15 3.65C11.05 3.75 11 3.86667 11 4V6H5V8.2C5.9 8.53333 6.625 9.09167 7.175 9.875C7.725 10.6583 8 11.5333 8 12.5C8 13.45 7.725 14.3167 7.175 15.1C6.625 15.8833 5.9 16.45 5 16.8V19Z"
        fill="currentColor"
      />
    </svg>
  ),
  filter: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.0461 20C10.7628 20 10.5253 19.9042 10.3336 19.7125C10.1419 19.5208 10.0461 19.2833 10.0461 19V13L4.2461 5.6C3.9961 5.26667 3.9586 4.91667 4.1336 4.55C4.3086 4.18333 4.61277 4 5.0461 4H19.0461C19.4794 4 19.7836 4.18333 19.9586 4.55C20.1336 4.91667 20.0961 5.26667 19.8461 5.6L14.0461 13V19C14.0461 19.2833 13.9503 19.5208 13.7586 19.7125C13.5669 19.9042 13.3294 20 13.0461 20H11.0461ZM12.0461 12.3L16.9961 6H7.0961L12.0461 12.3Z"
        fill="currentColor"
      />
    </svg>
  ),
  groups: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1286_4115)">
        <path
          d="M0 18V16.425C0 15.7083 0.366667 15.125 1.1 14.675C1.83333 14.225 2.8 14 4 14C4.21667 14 4.425 14.0042 4.625 14.0125C4.825 14.0208 5.01667 14.0417 5.2 14.075C4.96667 14.425 4.79167 14.7917 4.675 15.175C4.55833 15.5583 4.5 15.9583 4.5 16.375V18H0ZM6 18V16.375C6 15.8417 6.14583 15.3542 6.4375 14.9125C6.72917 14.4708 7.14167 14.0833 7.675 13.75C8.20833 13.4167 8.84583 13.1667 9.5875 13C10.3292 12.8333 11.1333 12.75 12 12.75C12.8833 12.75 13.6958 12.8333 14.4375 13C15.1792 13.1667 15.8167 13.4167 16.35 13.75C16.8833 14.0833 17.2917 14.4708 17.575 14.9125C17.8583 15.3542 18 15.8417 18 16.375V18H6ZM19.5 18V16.375C19.5 15.9417 19.4458 15.5333 19.3375 15.15C19.2292 14.7667 19.0667 14.4083 18.85 14.075C19.0333 14.0417 19.2208 14.0208 19.4125 14.0125C19.6042 14.0042 19.8 14 20 14C21.2 14 22.1667 14.2208 22.9 14.6625C23.6333 15.1042 24 15.6917 24 16.425V18H19.5ZM8.125 16H15.9C15.7333 15.6667 15.2708 15.375 14.5125 15.125C13.7542 14.875 12.9167 14.75 12 14.75C11.0833 14.75 10.2458 14.875 9.4875 15.125C8.72917 15.375 8.275 15.6667 8.125 16ZM4 13C3.45 13 2.97917 12.8042 2.5875 12.4125C2.19583 12.0208 2 11.55 2 11C2 10.4333 2.19583 9.95833 2.5875 9.575C2.97917 9.19167 3.45 9 4 9C4.56667 9 5.04167 9.19167 5.425 9.575C5.80833 9.95833 6 10.4333 6 11C6 11.55 5.80833 12.0208 5.425 12.4125C5.04167 12.8042 4.56667 13 4 13ZM20 13C19.45 13 18.9792 12.8042 18.5875 12.4125C18.1958 12.0208 18 11.55 18 11C18 10.4333 18.1958 9.95833 18.5875 9.575C18.9792 9.19167 19.45 9 20 9C20.5667 9 21.0417 9.19167 21.425 9.575C21.8083 9.95833 22 10.4333 22 11C22 11.55 21.8083 12.0208 21.425 12.4125C21.0417 12.8042 20.5667 13 20 13ZM12 12C11.1667 12 10.4583 11.7083 9.875 11.125C9.29167 10.5417 9 9.83333 9 9C9 8.15 9.29167 7.4375 9.875 6.8625C10.4583 6.2875 11.1667 6 12 6C12.85 6 13.5625 6.2875 14.1375 6.8625C14.7125 7.4375 15 8.15 15 9C15 9.83333 14.7125 10.5417 14.1375 11.125C13.5625 11.7083 12.85 12 12 12ZM12 10C12.2833 10 12.5208 9.90417 12.7125 9.7125C12.9042 9.52083 13 9.28333 13 9C13 8.71667 12.9042 8.47917 12.7125 8.2875C12.5208 8.09583 12.2833 8 12 8C11.7167 8 11.4792 8.09583 11.2875 8.2875C11.0958 8.47917 11 8.71667 11 9C11 9.28333 11.0958 9.52083 11.2875 9.7125C11.4792 9.90417 11.7167 10 12 10Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_1286_4115">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  hide: (width, height) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      fill="currentColor"
    >
      <path d="M0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0zm0 0h24v24H0z" fill="none" />
      <path d="M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z" />
    </svg>
  ),
  info: (width, height) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      fill="currentColor"
    >
      <path d="M11.19 18H12.99V10.8H11.19V18ZM11.9995 8.58C12.2798 8.58 12.515 8.488 12.705 8.304C12.895 8.12 12.99 7.892 12.99 7.62C12.99 7.331 12.8952 7.08875 12.7055 6.89325C12.5159 6.69775 12.2809 6.6 12.0005 6.6C11.7202 6.6 11.485 6.69775 11.295 6.89325C11.105 7.08875 11.01 7.331 11.01 7.62C11.01 7.892 11.1048 8.12 11.2945 8.304C11.4841 8.488 11.7191 8.58 11.9995 8.58ZM12.008 24C10.3533 24 8.7983 23.685 7.34298 23.055C5.88766 22.425 4.615 21.565 3.525 20.475C2.435 19.385 1.575 18.1116 0.945 16.6548C0.315 15.198 0 13.6414 0 11.985C0 10.3286 0.315 8.77203 0.945 7.31523C1.575 5.85841 2.435 4.59 3.525 3.51C4.615 2.43 5.88841 1.575 7.34523 0.945C8.80203 0.315 10.3586 0 12.015 0C13.6714 0 15.228 0.315 16.6848 0.945C18.1416 1.575 19.41 2.43 20.49 3.51C21.57 4.59 22.425 5.86 23.055 7.32C23.685 8.78 24 10.3373 24 11.992C24 13.6467 23.685 15.2017 23.055 16.657C22.425 18.1123 21.57 19.3832 20.49 20.4695C19.41 21.5558 18.14 22.4158 16.68 23.0495C15.22 23.6832 13.6627 24 12.008 24ZM12.015 22.2C14.845 22.2 17.25 21.205 19.23 19.215C21.21 17.225 22.2 14.815 22.2 11.985C22.2 9.155 21.2119 6.75 19.2356 4.77C17.2594 2.79 14.8475 1.8 12 1.8C9.18 1.8 6.775 2.78812 4.785 4.76436C2.795 6.74062 1.8 9.1525 1.8 12C1.8 14.82 2.795 17.225 4.785 19.215C6.775 21.205 9.185 22.2 12.015 22.2Z" />
    </svg>
  ),
  logout: (width, height) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill="currentColor"
    >
      <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h280v80H200v560h280v80H200Zm440-160-55-58 102-102H360v-80h327L585-622l55-58 200 200-200 200Z" />
    </svg>
  ),
  manufacturing: (width, height) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill="currentColor"
    >
      <path d="m234-480-12-60q-12-5-22.5-10.5T178-564l-58 18-40-68 46-40q-2-13-2-26t2-26l-46-40 40-68 58 18q11-8 21.5-13.5T222-820l12-60h80l12 60q12 5 22.5 10.5T370-796l58-18 40 68-46 40q2 13 2 26t-2 26l46 40-40 68-58-18q-11 8-21.5 13.5T326-540l-12 60h-80Zm40-120q33 0 56.5-23.5T354-680q0-33-23.5-56.5T274-760q-33 0-56.5 23.5T194-680q0 33 23.5 56.5T274-600ZM592-40l-18-84q-17-6-31.5-14.5T514-158l-80 26-56-96 64-56q-2-18-2-36t2-36l-64-56 56-96 80 26q14-11 28.5-19.5T574-516l18-84h112l18 84q17 6 31.5 14.5T782-482l80-26 56 96-64 56q2 18 2 36t-2 36l64 56-56 96-80-26q-14 11-28.5 19.5T722-124l-18 84H592Zm56-160q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Z" />
    </svg>
  ),
  menu: (width, height) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      fill="currentColor"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" />
    </svg>
  ),
  more_vert: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
        fill="currentColor"
      />
    </svg>
  ),
  note: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M240-80q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h320l240 240v480q0 33-23.5 56.5T720-80H240Zm280-520v-200H240v640h480v-440H520ZM240-800v200-200 640-640Z"
        fill="currentColor"
      />
    </svg>
  ),
  notifications_off: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 18.69L7.84 6.14L5.27 3.49L4 4.76L6.8 7.56V7.57C6.28 8.56 6 9.73 6 10.99V15.99L4 17.99V18.99H17.73L19.73 20.99L21 19.72L20 18.69ZM12 22C13.11 22 14 21.11 14 20H10C10 21.11 10.89 22 12 22ZM18 14.68V11C18 7.92 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C10.35 4.71 10.21 4.76 10.08 4.8C9.98 4.83 9.88 4.87 9.78 4.91H9.77C9.76 4.91 9.76 4.91 9.75 4.92C9.52 5.01 9.29 5.12 9.07 5.23C9.07 5.23 9.06 5.23 9.06 5.24L18 14.68Z"
        fill="currentColor"
      />
    </svg>
  ),
  notifications: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.89 22 12 22ZM18 16V11C18 7.93 16.36 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.63 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16Z"
        fill="currentColor"
      />
    </svg>
  ),
  people: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 23V21H20V23H4ZM4 3V1H20V3H4ZM12 13C12.8333 13 13.5417 12.7083 14.125 12.125C14.7083 11.5417 15 10.8333 15 10C15 9.16667 14.7083 8.45833 14.125 7.875C13.5417 7.29167 12.8333 7 12 7C11.1667 7 10.4583 7.29167 9.875 7.875C9.29167 8.45833 9 9.16667 9 10C9 10.8333 9.29167 11.5417 9.875 12.125C10.4583 12.7083 11.1667 13 12 13ZM4 20C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V18C22 18.55 21.8042 19.0208 21.4125 19.4125C21.0208 19.8042 20.55 20 20 20H4ZM5.75 18C6.5 17.0667 7.40833 16.3333 8.475 15.8C9.54167 15.2667 10.7167 15 12 15C13.2833 15 14.4583 15.2667 15.525 15.8C16.5917 16.3333 17.5 17.0667 18.25 18H20V6H4V18H5.75ZM8.7 18H15.3C14.8167 17.6667 14.2958 17.4167 13.7375 17.25C13.1792 17.0833 12.6 17 12 17C11.4 17 10.8208 17.0833 10.2625 17.25C9.70417 17.4167 9.18333 17.6667 8.7 18ZM12 11C11.7167 11 11.4792 10.9042 11.2875 10.7125C11.0958 10.5208 11 10.2833 11 10C11 9.71667 11.0958 9.47917 11.2875 9.2875C11.4792 9.09583 11.7167 9 12 9C12.2833 9 12.5208 9.09583 12.7125 9.2875C12.9042 9.47917 13 9.71667 13 10C13 10.2833 12.9042 10.5208 12.7125 10.7125C12.5208 10.9042 12.2833 11 12 11Z"
        fill="currentColor"
      />
    </svg>
  ),
  plus: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
        fill="currentColor"
      />
    </svg>
  ),
  profile: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 5C13.66 5 15 6.34 15 8C15 9.66 13.66 11 12 11C10.34 11 9 9.66 9 8C9 6.34 10.34 5 12 5ZM12 19.2C9.5 19.2 7.29 17.92 6 15.98C6.03 13.99 10 12.9 12 12.9C13.99 12.9 17.97 13.99 18 15.98C16.71 17.92 14.5 19.2 12 19.2Z"
        fill="currentColor"
      />
    </svg>
  ),
  refresh: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M480-160q-134 0-227-93t-93-227q0-134 93-227t227-93q69 0 132 28.5T720-690v-110h80v280H520v-80h168q-32-56-87.5-88T480-720q-100 0-170 70t-70 170q0 100 70 170t170 70q77 0 139-44t87-116h84q-28 106-114 173t-196 67Z"
        fill="currentColor"
      />
    </svg>
  ),
  search: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
        fill="currentColor"
      />
    </svg>
  ),
  settings: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m370-80-16-128q-13-5-24.5-12T307-235l-119 50L78-375l103-78q-1-7-1-13.5v-27q0-6.5 1-13.5L78-585l110-190 119 50q11-8 23-15t24-12l16-128h220l16 128q13 5 24.5 12t22.5 15l119-50 110 190-103 78q1 7 1 13.5v27q0 6.5-2 13.5l103 78-110 190-118-50q-11 8-23 15t-24 12L590-80H370Zm70-80h79l14-106q31-8 57.5-23.5T639-327l99 41 39-68-86-65q5-14 7-29.5t2-31.5q0-16-2-31.5t-7-29.5l86-65-39-68-99 42q-22-23-48.5-38.5T533-694l-13-106h-79l-14 106q-31 8-57.5 23.5T321-633l-99-41-39 68 86 64q-5 15-7 30t-2 32q0 16 2 31t7 30l-86 65 39 68 99-42q22 23 48.5 38.5T427-266l13 106Zm42-180q58 0 99-41t41-99q0-58-41-99t-99-41q-59 0-99.5 41T342-480q0 58 40.5 99t99.5 41Zm-2-140Z"
        fill="currentColor"
      />
    </svg>
  ),
  show: (width, height) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 0 24 24"
      width={width}
      fill="currentColor"
    >
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
    </svg>
  ),
  sms: (width, height) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      viewBox="0 -960 960 960"
      width={width}
      fill="currentColor"
    >
      <path d="M320-520q17 0 28.5-11.5T360-560q0-17-11.5-28.5T320-600q-17 0-28.5 11.5T280-560q0 17 11.5 28.5T320-520Zm160 0q17 0 28.5-11.5T520-560q0-17-11.5-28.5T480-600q-17 0-28.5 11.5T440-560q0 17 11.5 28.5T480-520Zm160 0q17 0 28.5-11.5T680-560q0-17-11.5-28.5T640-600q-17 0-28.5 11.5T600-560q0 17 11.5 28.5T640-520ZM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240L80-80Zm126-240h594v-480H160v525l46-45Zm-46 0v-480 480Z" />
    </svg>
  ),
  timer: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M360-840v-80h240v80H360Zm80 440h80v-240h-80v240Zm40 320q-74 0-139.5-28.5T226-186q-49-49-77.5-114.5T120-440q0-74 28.5-139.5T226-694q49-49 114.5-77.5T480-800q62 0 119 20t107 58l56-56 56 56-56 56q38 50 58 107t20 119q0 74-28.5 139.5T734-186q-49 49-114.5 77.5T480-80Zm0-80q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82Zm0-280Z"
        fill="currentColor"
      />
    </svg>
  ),
  transactional: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 13L4 8V18H13V20H4C3.45 20 2.97917 19.8042 2.5875 19.4125C2.19583 19.0208 2 18.55 2 18V6C2 5.45 2.19583 4.97917 2.5875 4.5875C2.97917 4.19583 3.45 4 4 4H20C20.55 4 21.0208 4.19583 21.4125 4.5875C21.8042 4.97917 22 5.45 22 6V13H20V8L12 13ZM12 11L20 6H4L12 11ZM19 23L17.6 21.6L19.175 20H15V18H19.175L17.575 16.4L19 15L23 19L19 23ZM4 8V19V13V13.075V6V8Z"
        fill="currentColor"
      />
    </svg>
  ),
  trash: (width, height) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="currentColor"
        stroke="currentColor"
        d="M6.525 21C6.1125 21 5.75938 20.8531 5.46563 20.5594C5.17188 20.2656 5.025 19.9125 5.025 19.5V5.25H4V3.75H8.7V3H15.3V3.75H20V5.25H18.975V19.5C18.975 19.9 18.825 20.25 18.525 20.55C18.225 20.85 17.875 21 17.475 21H6.525ZM17.475 5.25H6.525V19.5H17.475V5.25ZM9.175 17.35H10.675V7.375H9.175V17.35ZM13.325 17.35H14.825V7.375H13.325V17.35Z"
      />
    </svg>
  ),
  upload: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M9 16H15V10H19L12 3L5 10H9V16ZM5 18H19V20H5V18Z" fill="currentColor" />
    </svg>
  ),
  users: (width, height) => (
    <svg
      width={width}
      height={height}
      viewBox="0 -960 960 960"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="currentColor"
        d="M40-160v-112q0-34 17.5-62.5T104-378q62-31 126-46.5T360-440q66 0 130 15.5T616-378q29 15 46.5 43.5T680-272v112H40Zm720 0v-120q0-44-24.5-84.5T666-434q51 6 96 20.5t84 35.5q36 20 55 44.5t19 53.5v120H760ZM360-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47Zm400-160q0 66-47 113t-113 47q-11 0-28-2.5t-28-5.5q27-32 41.5-71t14.5-81q0-42-14.5-81T544-792q14-5 28-6.5t28-1.5q66 0 113 47t47 113ZM120-240h480v-32q0-11-5.5-20T580-306q-54-27-109-40.5T360-360q-56 0-111 13.5T140-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T440-640q0-33-23.5-56.5T360-720q-33 0-56.5 23.5T280-640q0 33 23.5 56.5T360-560Zm0 320Zm0-400Z"
      />
    </svg>
  )
};
